import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  CodeValidate,
  EmailRequest,
  PasswordChange,
  PasswordData,
  PasswordResponse,
} from '../../_interfaces/password-interface';
import { Observable } from 'rxjs';
import { ValidTokenResponse } from '../../_interfaces/verify-account';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_PASSWORD_RESET: string = 'password/reset';
  URL_PASSWORD_REQUEST: string = 'password/reset-code';
  URL_PASSWORD_CHANGE: string = 'password/change';
  URL_PASSWORD_VALID: string = 'password/valid';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * User requests their password to be reset by inputting their email address
   *
   * @returns Observable<PasswordResponse>
   * @param data
   */
  requestEmail(data: EmailRequest): Observable<PasswordResponse> {
    return this.http.post<PasswordResponse>(this.getUrl(this.URL_PASSWORD_REQUEST, true), data);
  }

  /**
   * Validates the reset password code.
   *
   * @returns Observable<ValidTokenResponse>
   * @param data
   */
  validateCode(data: CodeValidate): Observable<ValidTokenResponse> {
    return this.http.post<ValidTokenResponse>(this.getUrl(this.URL_PASSWORD_VALID, true), data);
  }

  /**
   * Send reset password request
   *
   * @returns Observable<PasswordResponse>
   * @param data
   */
  resetPassword(data: PasswordData): Observable<PasswordResponse> {
    return this.http.post<PasswordResponse>(this.getUrl(this.URL_PASSWORD_RESET, true), data);
  }

  /**
   * Send change password request (from settings page)
   *
   * @returns Observable<PasswordResponse>
   * @param data
   */
  changePassword(data: PasswordChange): Observable<PasswordResponse> {
    return this.http.post<PasswordResponse>(this.getUrl(this.URL_PASSWORD_CHANGE, true), data);
  }
}
